/**
 * 相对时间格式化（口径同源 App `timeFormat.ts`，story AC-4）。
 *  ≤60s → 刚刚 / ≤60min → N 分钟前 / 当天 → HH:mm / 昨天 → 昨天 HH:mm /
 *  当年 → MM-DD / 跨年 → YYYY-MM-DD。
 * 入参为 ISO 字符串或 epoch ms；空 / 解析失败 → 返回空串（调用方据此守卫不渲染）。
 */
export function formatRelativeTime(input: string | number | null | undefined, now: number = Date.now()): string {
  if (input == null || input === '') return '';
  const ts = typeof input === 'number' ? input : Date.parse(input);
  if (Number.isNaN(ts)) return '';

  const diffMs = now - ts;
  if (diffMs < 0) {
    // 未来时间（时钟漂移）：按当天 HH:mm 兜底。
    return hhmm(ts);
  }
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec <= 60) return '刚刚';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)} 分钟前`;

  const d = new Date(ts);
  const n = new Date(now);
  if (isSameDay(d, n)) return hhmm(ts);

  const yesterday = new Date(now);
  yesterday.setDate(n.getDate() - 1);
  if (isSameDay(d, yesterday)) return `昨天 ${hhmm(ts)}`;

  if (d.getFullYear() === n.getFullYear()) {
    return `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

function hhmm(ts: number): string {
  const d = new Date(ts);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}
